import AltQuoteOffers from "./AltQuoteOffers";

export default AltQuoteOffers;
